<div>
  <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
</div>
<div class="container fixed-min-500" *ngIf="!isLoading">
  <div class="card p-3">
    <full-calendar
      [options]="calendarOptions"
      [events]="currentEvents"></full-calendar>
  </div>
</div>
<app-general-empty-modal #modal [modalConfig]="modalConfig">
  <ng-container *ngIf="selectedClickDate">
    <app-modal-add-sessionv2
      (closeModalEmitter)="closeModal($event)"
      [currentEventSelected]="null"
      [selectedClickDate]="selectedClickDate"></app-modal-add-sessionv2>
  </ng-container>
</app-general-empty-modal>

<app-general-empty-modal #modalEdit [modalConfig]="modalConfig">
  <ng-container *ngIf="selectedEvent && selectedClickDate">
    <app-modal-add-sessionv2
      (closeModalEmitter)="closeModal($event)"
      [currentEventSelected]="selectedEvent"
      [selectedClickDate]="selectedClickDate"></app-modal-add-sessionv2>
  </ng-container>
</app-general-empty-modal>
